import { render, staticRenderFns } from "./TaskMenuRight.vue?vue&type=template&id=282d7f7f&"
import script from "./TaskMenuRight.vue?vue&type=script&lang=js&"
export * from "./TaskMenuRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports